module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch_img"
  }, [_c('img', {
    attrs: {
      "alt": "IMages",
      "src": "images/ch1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jack’s parents hovered over the sofa, shoving clothes into duffel bags. Jack tiptoed across the living room. Standing behind them, he whispered, “What are you doing? Running away?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Richard and Claire Berenson whirled to face Jack. They looked as if they had been caught robbing a bank.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You "), _c('i', [_vm._v("are")]), _vm._v(" running away!” Jack said. “Without me?” Jack thought his family had finally settled into a comfortable routine. They were back in his old neighborhood in Pennsylvania, with the Berenson Family Rules hung on the refrigerator.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "IMages",
      "src": "images/img_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jack,” his dad said, “there you are. Right there behind us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t be a goose, Jack,” his mom said. “Of course we’re not running away. If we ever go on the run, you’ll be the first thing we pack. We’re just—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Organizing,” his dad said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Organizing?” Jack said. That wasn’t likely. “Tell me what’s going on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, we did try to tell you,” his mom said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Spelled it out every which way,” his dad added.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Remember, Jack,” his mom said, “when we went to the Renaissance Fair for dinner? Right through the whole jousting tournament, your dad and I observed that life is an adventure. Don’t you adore airports, we asked, and aren’t elephants amazing, and isn’t camping divine?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jack did remember that. He had told the medieval serving wench not to give them any more mead. “What were you trying to tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His mom blurted out, “We’re going to Africa!”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee45c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 75
// module chunks = 0